import { Content, PageWithHeader } from '@backstage/core-components';
import React from 'react';
import { SystemLandscapeCard } from '../../cards/SystemLandscapeCard';

export const SystemLandscapePage = () => (
  <PageWithHeader
    themeId="systems"
    title="System Landscape"
    pageTitleOverride="System Landscape"
  >
    <Content>
      <SystemLandscapeCard></SystemLandscapeCard>
    </Content>
  </PageWithHeader>
);
